import React, { FC } from 'react';

import { useFormikContext } from 'formik';

import { StoreThemeFormValues } from '../../StoreTheme/storeTheme.types';

import { FormField } from './FormField';

type EmptyStateFormValues = Pick<
  StoreThemeFormValues,
  'noOffersTitleText' | 'noOffersMessageText'
>;

export const EmptyStateSectionFields: FC = () => {
  const { values, handleBlur, handleChange, errors, touched } =
    useFormikContext<EmptyStateFormValues>();

  return (
    <div className="mt-1 grid grid-cols-1 gap-9 md:grid-cols-2 md:col-span-2 [&_input:not([aria-invalid])]:border-zinc-200 [&_input]:placeholder:text-base-mutedForeground">
      <FormField
        label="Empty State Title"
        name="noOffersTitleText"
        value={values.noOffersTitleText}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.noOffersTitleText && Boolean(errors.noOffersTitleText)}
        helperText={
          touched.noOffersTitleText
            ? errors.noOffersTitleText?.toString()
            : undefined
        }
        placeholder="No Offers Available"
        dataTestId="noOffersTitleText"
      />
      <FormField
        label="Empty State Body Text"
        name="noOffersMessageText"
        value={values.noOffersMessageText}
        onChange={handleChange}
        onBlur={handleBlur}
        error={
          touched.noOffersMessageText && Boolean(errors.noOffersMessageText)
        }
        helperText={
          touched.noOffersMessageText
            ? errors.noOffersMessageText?.toString()
            : undefined
        }
        placeholder="No offers are available at the moment. Try again soon!"
        dataTestId="noOffersMessageText"
      />
    </div>
  );
};
